const mockFollowers = [
  {
    login: "vasilpa",
    id: 11231630,
    node_id: "MDQ6VXNlcjExMjMxNjMw",
    avatar_url: "https://avatars.githubusercontent.com/u/11231630?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/vasilpa",
    html_url: "https://github.com/vasilpa",
    followers_url: "https://api.github.com/users/vasilpa/followers",
    following_url:
      "https://api.github.com/users/vasilpa/following{/other_user}",
    gists_url: "https://api.github.com/users/vasilpa/gists{/gist_id}",
    starred_url: "https://api.github.com/users/vasilpa/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/vasilpa/subscriptions",
    organizations_url: "https://api.github.com/users/vasilpa/orgs",
    repos_url: "https://api.github.com/users/vasilpa/repos",
    events_url: "https://api.github.com/users/vasilpa/events{/privacy}",
    received_events_url: "https://api.github.com/users/vasilpa/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "faizanakram99",
    id: 10880992,
    node_id: "MDQ6VXNlcjEwODgwOTky",
    avatar_url: "https://avatars.githubusercontent.com/u/10880992?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/faizanakram99",
    html_url: "https://github.com/faizanakram99",
    followers_url: "https://api.github.com/users/faizanakram99/followers",
    following_url:
      "https://api.github.com/users/faizanakram99/following{/other_user}",
    gists_url: "https://api.github.com/users/faizanakram99/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/faizanakram99/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/faizanakram99/subscriptions",
    organizations_url: "https://api.github.com/users/faizanakram99/orgs",
    repos_url: "https://api.github.com/users/faizanakram99/repos",
    events_url: "https://api.github.com/users/faizanakram99/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/faizanakram99/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "tuanphungcz",
    id: 16448321,
    node_id: "MDQ6VXNlcjE2NDQ4MzIx",
    avatar_url: "https://avatars.githubusercontent.com/u/16448321?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/tuanphungcz",
    html_url: "https://github.com/tuanphungcz",
    followers_url: "https://api.github.com/users/tuanphungcz/followers",
    following_url:
      "https://api.github.com/users/tuanphungcz/following{/other_user}",
    gists_url: "https://api.github.com/users/tuanphungcz/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/tuanphungcz/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/tuanphungcz/subscriptions",
    organizations_url: "https://api.github.com/users/tuanphungcz/orgs",
    repos_url: "https://api.github.com/users/tuanphungcz/repos",
    events_url: "https://api.github.com/users/tuanphungcz/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/tuanphungcz/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "jielinko",
    id: 12973967,
    node_id: "MDQ6VXNlcjEyOTczOTY3",
    avatar_url: "https://avatars.githubusercontent.com/u/12973967?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/jielinko",
    html_url: "https://github.com/jielinko",
    followers_url: "https://api.github.com/users/jielinko/followers",
    following_url:
      "https://api.github.com/users/jielinko/following{/other_user}",
    gists_url: "https://api.github.com/users/jielinko/gists{/gist_id}",
    starred_url: "https://api.github.com/users/jielinko/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/jielinko/subscriptions",
    organizations_url: "https://api.github.com/users/jielinko/orgs",
    repos_url: "https://api.github.com/users/jielinko/repos",
    events_url: "https://api.github.com/users/jielinko/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/jielinko/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "jwright04",
    id: 1173150,
    node_id: "MDQ6VXNlcjExNzMxNTA=",
    avatar_url: "https://avatars.githubusercontent.com/u/1173150?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/jwright04",
    html_url: "https://github.com/jwright04",
    followers_url: "https://api.github.com/users/jwright04/followers",
    following_url:
      "https://api.github.com/users/jwright04/following{/other_user}",
    gists_url: "https://api.github.com/users/jwright04/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/jwright04/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/jwright04/subscriptions",
    organizations_url: "https://api.github.com/users/jwright04/orgs",
    repos_url: "https://api.github.com/users/jwright04/repos",
    events_url: "https://api.github.com/users/jwright04/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/jwright04/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "mortl",
    id: 3196919,
    node_id: "MDQ6VXNlcjMxOTY5MTk=",
    avatar_url: "https://avatars.githubusercontent.com/u/3196919?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/mortl",
    html_url: "https://github.com/mortl",
    followers_url: "https://api.github.com/users/mortl/followers",
    following_url: "https://api.github.com/users/mortl/following{/other_user}",
    gists_url: "https://api.github.com/users/mortl/gists{/gist_id}",
    starred_url: "https://api.github.com/users/mortl/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/mortl/subscriptions",
    organizations_url: "https://api.github.com/users/mortl/orgs",
    repos_url: "https://api.github.com/users/mortl/repos",
    events_url: "https://api.github.com/users/mortl/events{/privacy}",
    received_events_url: "https://api.github.com/users/mortl/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "OfeliaMuradova",
    id: 16364918,
    node_id: "MDQ6VXNlcjE2MzY0OTE4",
    avatar_url: "https://avatars.githubusercontent.com/u/16364918?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/OfeliaMuradova",
    html_url: "https://github.com/OfeliaMuradova",
    followers_url: "https://api.github.com/users/OfeliaMuradova/followers",
    following_url:
      "https://api.github.com/users/OfeliaMuradova/following{/other_user}",
    gists_url: "https://api.github.com/users/OfeliaMuradova/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/OfeliaMuradova/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/OfeliaMuradova/subscriptions",
    organizations_url: "https://api.github.com/users/OfeliaMuradova/orgs",
    repos_url: "https://api.github.com/users/OfeliaMuradova/repos",
    events_url: "https://api.github.com/users/OfeliaMuradova/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/OfeliaMuradova/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "dawei530",
    id: 1804519,
    node_id: "MDQ6VXNlcjE4MDQ1MTk=",
    avatar_url: "https://avatars.githubusercontent.com/u/1804519?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/dawei530",
    html_url: "https://github.com/dawei530",
    followers_url: "https://api.github.com/users/dawei530/followers",
    following_url:
      "https://api.github.com/users/dawei530/following{/other_user}",
    gists_url: "https://api.github.com/users/dawei530/gists{/gist_id}",
    starred_url: "https://api.github.com/users/dawei530/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/dawei530/subscriptions",
    organizations_url: "https://api.github.com/users/dawei530/orgs",
    repos_url: "https://api.github.com/users/dawei530/repos",
    events_url: "https://api.github.com/users/dawei530/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/dawei530/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Guikingone",
    id: 13744329,
    node_id: "MDQ6VXNlcjEzNzQ0MzI5",
    avatar_url: "https://avatars.githubusercontent.com/u/13744329?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Guikingone",
    html_url: "https://github.com/Guikingone",
    followers_url: "https://api.github.com/users/Guikingone/followers",
    following_url:
      "https://api.github.com/users/Guikingone/following{/other_user}",
    gists_url: "https://api.github.com/users/Guikingone/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Guikingone/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Guikingone/subscriptions",
    organizations_url: "https://api.github.com/users/Guikingone/orgs",
    repos_url: "https://api.github.com/users/Guikingone/repos",
    events_url: "https://api.github.com/users/Guikingone/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Guikingone/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "fakocher",
    id: 2465947,
    node_id: "MDQ6VXNlcjI0NjU5NDc=",
    avatar_url: "https://avatars.githubusercontent.com/u/2465947?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/fakocher",
    html_url: "https://github.com/fakocher",
    followers_url: "https://api.github.com/users/fakocher/followers",
    following_url:
      "https://api.github.com/users/fakocher/following{/other_user}",
    gists_url: "https://api.github.com/users/fakocher/gists{/gist_id}",
    starred_url: "https://api.github.com/users/fakocher/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/fakocher/subscriptions",
    organizations_url: "https://api.github.com/users/fakocher/orgs",
    repos_url: "https://api.github.com/users/fakocher/repos",
    events_url: "https://api.github.com/users/fakocher/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/fakocher/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "mediasittich",
    id: 5382877,
    node_id: "MDQ6VXNlcjUzODI4Nzc=",
    avatar_url: "https://avatars.githubusercontent.com/u/5382877?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/mediasittich",
    html_url: "https://github.com/mediasittich",
    followers_url: "https://api.github.com/users/mediasittich/followers",
    following_url:
      "https://api.github.com/users/mediasittich/following{/other_user}",
    gists_url: "https://api.github.com/users/mediasittich/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/mediasittich/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/mediasittich/subscriptions",
    organizations_url: "https://api.github.com/users/mediasittich/orgs",
    repos_url: "https://api.github.com/users/mediasittich/repos",
    events_url: "https://api.github.com/users/mediasittich/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/mediasittich/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "LuisManuel1983",
    id: 16975334,
    node_id: "MDQ6VXNlcjE2OTc1MzM0",
    avatar_url: "https://avatars.githubusercontent.com/u/16975334?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/LuisManuel1983",
    html_url: "https://github.com/LuisManuel1983",
    followers_url: "https://api.github.com/users/LuisManuel1983/followers",
    following_url:
      "https://api.github.com/users/LuisManuel1983/following{/other_user}",
    gists_url: "https://api.github.com/users/LuisManuel1983/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/LuisManuel1983/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/LuisManuel1983/subscriptions",
    organizations_url: "https://api.github.com/users/LuisManuel1983/orgs",
    repos_url: "https://api.github.com/users/LuisManuel1983/repos",
    events_url: "https://api.github.com/users/LuisManuel1983/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/LuisManuel1983/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "cristhiansagun",
    id: 8233934,
    node_id: "MDQ6VXNlcjgyMzM5MzQ=",
    avatar_url: "https://avatars.githubusercontent.com/u/8233934?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/cristhiansagun",
    html_url: "https://github.com/cristhiansagun",
    followers_url: "https://api.github.com/users/cristhiansagun/followers",
    following_url:
      "https://api.github.com/users/cristhiansagun/following{/other_user}",
    gists_url: "https://api.github.com/users/cristhiansagun/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/cristhiansagun/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/cristhiansagun/subscriptions",
    organizations_url: "https://api.github.com/users/cristhiansagun/orgs",
    repos_url: "https://api.github.com/users/cristhiansagun/repos",
    events_url: "https://api.github.com/users/cristhiansagun/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/cristhiansagun/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "patrykrosenkiewicz",
    id: 17979049,
    node_id: "MDQ6VXNlcjE3OTc5MDQ5",
    avatar_url: "https://avatars.githubusercontent.com/u/17979049?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/patrykrosenkiewicz",
    html_url: "https://github.com/patrykrosenkiewicz",
    followers_url: "https://api.github.com/users/patrykrosenkiewicz/followers",
    following_url:
      "https://api.github.com/users/patrykrosenkiewicz/following{/other_user}",
    gists_url:
      "https://api.github.com/users/patrykrosenkiewicz/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/patrykrosenkiewicz/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/patrykrosenkiewicz/subscriptions",
    organizations_url: "https://api.github.com/users/patrykrosenkiewicz/orgs",
    repos_url: "https://api.github.com/users/patrykrosenkiewicz/repos",
    events_url:
      "https://api.github.com/users/patrykrosenkiewicz/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/patrykrosenkiewicz/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "jesueljr",
    id: 1185014,
    node_id: "MDQ6VXNlcjExODUwMTQ=",
    avatar_url: "https://avatars.githubusercontent.com/u/1185014?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/jesueljr",
    html_url: "https://github.com/jesueljr",
    followers_url: "https://api.github.com/users/jesueljr/followers",
    following_url:
      "https://api.github.com/users/jesueljr/following{/other_user}",
    gists_url: "https://api.github.com/users/jesueljr/gists{/gist_id}",
    starred_url: "https://api.github.com/users/jesueljr/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/jesueljr/subscriptions",
    organizations_url: "https://api.github.com/users/jesueljr/orgs",
    repos_url: "https://api.github.com/users/jesueljr/repos",
    events_url: "https://api.github.com/users/jesueljr/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/jesueljr/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "dmvsp",
    id: 1425192,
    node_id: "MDQ6VXNlcjE0MjUxOTI=",
    avatar_url: "https://avatars.githubusercontent.com/u/1425192?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/dmvsp",
    html_url: "https://github.com/dmvsp",
    followers_url: "https://api.github.com/users/dmvsp/followers",
    following_url: "https://api.github.com/users/dmvsp/following{/other_user}",
    gists_url: "https://api.github.com/users/dmvsp/gists{/gist_id}",
    starred_url: "https://api.github.com/users/dmvsp/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/dmvsp/subscriptions",
    organizations_url: "https://api.github.com/users/dmvsp/orgs",
    repos_url: "https://api.github.com/users/dmvsp/repos",
    events_url: "https://api.github.com/users/dmvsp/events{/privacy}",
    received_events_url: "https://api.github.com/users/dmvsp/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "axelrindle",
    id: 7105632,
    node_id: "MDQ6VXNlcjcxMDU2MzI=",
    avatar_url: "https://avatars.githubusercontent.com/u/7105632?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/axelrindle",
    html_url: "https://github.com/axelrindle",
    followers_url: "https://api.github.com/users/axelrindle/followers",
    following_url:
      "https://api.github.com/users/axelrindle/following{/other_user}",
    gists_url: "https://api.github.com/users/axelrindle/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/axelrindle/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/axelrindle/subscriptions",
    organizations_url: "https://api.github.com/users/axelrindle/orgs",
    repos_url: "https://api.github.com/users/axelrindle/repos",
    events_url: "https://api.github.com/users/axelrindle/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/axelrindle/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "chatajazzy",
    id: 13948431,
    node_id: "MDQ6VXNlcjEzOTQ4NDMx",
    avatar_url: "https://avatars.githubusercontent.com/u/13948431?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/chatajazzy",
    html_url: "https://github.com/chatajazzy",
    followers_url: "https://api.github.com/users/chatajazzy/followers",
    following_url:
      "https://api.github.com/users/chatajazzy/following{/other_user}",
    gists_url: "https://api.github.com/users/chatajazzy/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/chatajazzy/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/chatajazzy/subscriptions",
    organizations_url: "https://api.github.com/users/chatajazzy/orgs",
    repos_url: "https://api.github.com/users/chatajazzy/repos",
    events_url: "https://api.github.com/users/chatajazzy/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/chatajazzy/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "jbienesdev",
    id: 17470909,
    node_id: "MDQ6VXNlcjE3NDcwOTA5",
    avatar_url: "https://avatars.githubusercontent.com/u/17470909?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/jbienesdev",
    html_url: "https://github.com/jbienesdev",
    followers_url: "https://api.github.com/users/jbienesdev/followers",
    following_url:
      "https://api.github.com/users/jbienesdev/following{/other_user}",
    gists_url: "https://api.github.com/users/jbienesdev/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/jbienesdev/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/jbienesdev/subscriptions",
    organizations_url: "https://api.github.com/users/jbienesdev/orgs",
    repos_url: "https://api.github.com/users/jbienesdev/repos",
    events_url: "https://api.github.com/users/jbienesdev/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/jbienesdev/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "aurelienroux",
    id: 16433082,
    node_id: "MDQ6VXNlcjE2NDMzMDgy",
    avatar_url: "https://avatars.githubusercontent.com/u/16433082?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/aurelienroux",
    html_url: "https://github.com/aurelienroux",
    followers_url: "https://api.github.com/users/aurelienroux/followers",
    following_url:
      "https://api.github.com/users/aurelienroux/following{/other_user}",
    gists_url: "https://api.github.com/users/aurelienroux/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/aurelienroux/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/aurelienroux/subscriptions",
    organizations_url: "https://api.github.com/users/aurelienroux/orgs",
    repos_url: "https://api.github.com/users/aurelienroux/repos",
    events_url: "https://api.github.com/users/aurelienroux/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/aurelienroux/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "admiralrohan",
    id: 12814060,
    node_id: "MDQ6VXNlcjEyODE0MDYw",
    avatar_url: "https://avatars.githubusercontent.com/u/12814060?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/admiralrohan",
    html_url: "https://github.com/admiralrohan",
    followers_url: "https://api.github.com/users/admiralrohan/followers",
    following_url:
      "https://api.github.com/users/admiralrohan/following{/other_user}",
    gists_url: "https://api.github.com/users/admiralrohan/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/admiralrohan/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/admiralrohan/subscriptions",
    organizations_url: "https://api.github.com/users/admiralrohan/orgs",
    repos_url: "https://api.github.com/users/admiralrohan/repos",
    events_url: "https://api.github.com/users/admiralrohan/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/admiralrohan/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "approximata",
    id: 13140886,
    node_id: "MDQ6VXNlcjEzMTQwODg2",
    avatar_url: "https://avatars.githubusercontent.com/u/13140886?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/approximata",
    html_url: "https://github.com/approximata",
    followers_url: "https://api.github.com/users/approximata/followers",
    following_url:
      "https://api.github.com/users/approximata/following{/other_user}",
    gists_url: "https://api.github.com/users/approximata/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/approximata/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/approximata/subscriptions",
    organizations_url: "https://api.github.com/users/approximata/orgs",
    repos_url: "https://api.github.com/users/approximata/repos",
    events_url: "https://api.github.com/users/approximata/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/approximata/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Pfeter",
    id: 16732830,
    node_id: "MDQ6VXNlcjE2NzMyODMw",
    avatar_url: "https://avatars.githubusercontent.com/u/16732830?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Pfeter",
    html_url: "https://github.com/Pfeter",
    followers_url: "https://api.github.com/users/Pfeter/followers",
    following_url: "https://api.github.com/users/Pfeter/following{/other_user}",
    gists_url: "https://api.github.com/users/Pfeter/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Pfeter/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Pfeter/subscriptions",
    organizations_url: "https://api.github.com/users/Pfeter/orgs",
    repos_url: "https://api.github.com/users/Pfeter/repos",
    events_url: "https://api.github.com/users/Pfeter/events{/privacy}",
    received_events_url: "https://api.github.com/users/Pfeter/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "iamsalimali",
    id: 17379867,
    node_id: "MDQ6VXNlcjE3Mzc5ODY3",
    avatar_url: "https://avatars.githubusercontent.com/u/17379867?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/iamsalimali",
    html_url: "https://github.com/iamsalimali",
    followers_url: "https://api.github.com/users/iamsalimali/followers",
    following_url:
      "https://api.github.com/users/iamsalimali/following{/other_user}",
    gists_url: "https://api.github.com/users/iamsalimali/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/iamsalimali/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/iamsalimali/subscriptions",
    organizations_url: "https://api.github.com/users/iamsalimali/orgs",
    repos_url: "https://api.github.com/users/iamsalimali/repos",
    events_url: "https://api.github.com/users/iamsalimali/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/iamsalimali/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Omosofe",
    id: 13411027,
    node_id: "MDQ6VXNlcjEzNDExMDI3",
    avatar_url: "https://avatars.githubusercontent.com/u/13411027?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Omosofe",
    html_url: "https://github.com/Omosofe",
    followers_url: "https://api.github.com/users/Omosofe/followers",
    following_url:
      "https://api.github.com/users/Omosofe/following{/other_user}",
    gists_url: "https://api.github.com/users/Omosofe/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Omosofe/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Omosofe/subscriptions",
    organizations_url: "https://api.github.com/users/Omosofe/orgs",
    repos_url: "https://api.github.com/users/Omosofe/repos",
    events_url: "https://api.github.com/users/Omosofe/events{/privacy}",
    received_events_url: "https://api.github.com/users/Omosofe/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "ivarmlee11",
    id: 6400575,
    node_id: "MDQ6VXNlcjY0MDA1NzU=",
    avatar_url: "https://avatars.githubusercontent.com/u/6400575?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/ivarmlee11",
    html_url: "https://github.com/ivarmlee11",
    followers_url: "https://api.github.com/users/ivarmlee11/followers",
    following_url:
      "https://api.github.com/users/ivarmlee11/following{/other_user}",
    gists_url: "https://api.github.com/users/ivarmlee11/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/ivarmlee11/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/ivarmlee11/subscriptions",
    organizations_url: "https://api.github.com/users/ivarmlee11/orgs",
    repos_url: "https://api.github.com/users/ivarmlee11/repos",
    events_url: "https://api.github.com/users/ivarmlee11/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/ivarmlee11/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "woniu123360",
    id: 4693788,
    node_id: "MDQ6VXNlcjQ2OTM3ODg=",
    avatar_url: "https://avatars.githubusercontent.com/u/4693788?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/woniu123360",
    html_url: "https://github.com/woniu123360",
    followers_url: "https://api.github.com/users/woniu123360/followers",
    following_url:
      "https://api.github.com/users/woniu123360/following{/other_user}",
    gists_url: "https://api.github.com/users/woniu123360/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/woniu123360/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/woniu123360/subscriptions",
    organizations_url: "https://api.github.com/users/woniu123360/orgs",
    repos_url: "https://api.github.com/users/woniu123360/repos",
    events_url: "https://api.github.com/users/woniu123360/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/woniu123360/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "mark-shark",
    id: 13920098,
    node_id: "MDQ6VXNlcjEzOTIwMDk4",
    avatar_url: "https://avatars.githubusercontent.com/u/13920098?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/mark-shark",
    html_url: "https://github.com/mark-shark",
    followers_url: "https://api.github.com/users/mark-shark/followers",
    following_url:
      "https://api.github.com/users/mark-shark/following{/other_user}",
    gists_url: "https://api.github.com/users/mark-shark/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/mark-shark/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/mark-shark/subscriptions",
    organizations_url: "https://api.github.com/users/mark-shark/orgs",
    repos_url: "https://api.github.com/users/mark-shark/repos",
    events_url: "https://api.github.com/users/mark-shark/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/mark-shark/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "LantareCode",
    id: 13568352,
    node_id: "MDQ6VXNlcjEzNTY4MzUy",
    avatar_url: "https://avatars.githubusercontent.com/u/13568352?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/LantareCode",
    html_url: "https://github.com/LantareCode",
    followers_url: "https://api.github.com/users/LantareCode/followers",
    following_url:
      "https://api.github.com/users/LantareCode/following{/other_user}",
    gists_url: "https://api.github.com/users/LantareCode/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/LantareCode/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/LantareCode/subscriptions",
    organizations_url: "https://api.github.com/users/LantareCode/orgs",
    repos_url: "https://api.github.com/users/LantareCode/repos",
    events_url: "https://api.github.com/users/LantareCode/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/LantareCode/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Mrivera543",
    id: 5554626,
    node_id: "MDQ6VXNlcjU1NTQ2MjY=",
    avatar_url: "https://avatars.githubusercontent.com/u/5554626?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Mrivera543",
    html_url: "https://github.com/Mrivera543",
    followers_url: "https://api.github.com/users/Mrivera543/followers",
    following_url:
      "https://api.github.com/users/Mrivera543/following{/other_user}",
    gists_url: "https://api.github.com/users/Mrivera543/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Mrivera543/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Mrivera543/subscriptions",
    organizations_url: "https://api.github.com/users/Mrivera543/orgs",
    repos_url: "https://api.github.com/users/Mrivera543/repos",
    events_url: "https://api.github.com/users/Mrivera543/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Mrivera543/received_events",
    type: "User",
    site_admin: false,
  },
];

export default mockFollowers;
